// Force a fresh login after the app's LAST tab was closed — session cookies
// only die with the whole browser, so cookie mechanics alone can't do this.
//
// How: every open tab heartbeats into localStorage; each tab also marks itself
// in sessionStorage (survives reload + tab-duplicate, dies with the tab).
// On startup:
//   • sessionStorage marker present  → same tab reloading         → continue
//   • heartbeat fresher than 15s     → another app tab is open    → continue
//   • otherwise                      → fresh start after close    → re-login
// A crash or long sleep with no tabs open also lands on "fresh start", which
// is the conservative (safe) direction.
const HB_KEY = 'mrpcomp:tab-heartbeat';
const ALIVE_KEY = 'mrpcomp:tab-alive';
const HB_FRESH_MS = 15_000;

export function startTabSessionGuard(): 'continuation' | 'fresh-start' {
  let verdict: 'continuation' | 'fresh-start';
  try {
    const hb = Number(localStorage.getItem(HB_KEY)) || 0;
    verdict = sessionStorage.getItem(ALIVE_KEY)
      ? 'continuation'
      : Date.now() - hb < HB_FRESH_MS ? 'continuation' : 'fresh-start';
    sessionStorage.setItem(ALIVE_KEY, '1');
    localStorage.setItem(HB_KEY, String(Date.now()));
    window.setInterval(() => localStorage.setItem(HB_KEY, String(Date.now())), 5_000);
  } catch {
    verdict = 'continuation'; // storage unavailable — never lock the user out
  }
  return verdict;
}
